<template>
  <div class="history-container">
    <div class="content">
      <h2>{{$t('history.title')}}</h2>

      <InfoRowButton
        icon="/assets/images/cabinet_account_activity.svg"
        :method="this.$t('history.accountActivity')"
        @click="accountActivity">
      </InfoRowButton>
      <InfoRowButton
        icon="/assets/images/cabinet_trading_history.svg"
        :method="this.$t('history.tradingHistory')"
        @click="tradingHistory">
      </InfoRowButton>
    </div>
  </div>
</template>

<script>
import InfoRowButton from "@/components/InfoRowButton";
import {onMounted, ref} from "@vue/runtime-core";
import {getCurrentInstance} from "@vue/runtime-core";
import store from "@/store";

export default {
  name: "Deposit",
  components: {
    InfoRowButton
  },
  methods: {
    accountActivity() {
      this.$router.push('/cabinet/console/account_activity').catch(err => {
      });
    },
    tradingHistory() {
      this.$router.push('/cabinet/console/trading_history').catch(err => {
      });
    }
  },
  setup () {

    const internalInstance = getCurrentInstance()
    const emitter = internalInstance.appContext.config.globalProperties.emitter

    return {
    }
  }
}
</script>

<style scoped>

</style>
